import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconEnterReturn = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.06514 14.3186C4.02328 14.4121 4 14.5159 4 14.625C4 14.7298 4.02145 14.8295 4.06021 14.9201C4.09651 15.0052 4.14925 15.0849 4.2184 15.1545L4.22001 15.1561L8.4689 19.405C8.76222 19.6983 9.2378 19.6983 9.53112 19.405C9.82445 19.1117 9.82445 18.6361 9.53112 18.3428L6.56444 15.3761L12.7478 15.3761C12.7616 15.3761 12.7753 15.3757 12.7889 15.375H15.25C17.3211 15.375 19 13.6961 19 11.625L19 5.125C19 4.71079 18.6642 4.375 18.25 4.375C17.8358 4.375 17.5 4.71079 17.5 5.125L17.5 11.625C17.5 12.8676 16.4926 13.875 15.25 13.875H12.789C12.7753 13.8743 12.7616 13.8739 12.7478 13.8739L6.56446 13.8739L9.53113 10.9072C9.82445 10.6139 9.82445 10.1383 9.53113 9.84499C9.2378 9.55167 8.76223 9.55167 8.4689 9.845L4.22001 14.0939C4.20881 14.1051 4.19803 14.1166 4.18769 14.1283L4.06514 14.3186Z",
		fill: "currentColor"
	})
});
export { SvgIconEnterReturn as ReactComponent };
